export const BUTTON_WIDTH = "auto";
export const DROPDOWN_SCROLL_WIDTH = "500px";
export const DROPDOWN_SCROLL_MIN = 76;
export const DROPDOWN_SCROLL_HEIGHT_MAX = 276;
